export default __webpack_public_path__ + "static/media/empty.76b1f540.svg";